// apps/web/src/layouts/components/SidebarSupportBadge.tsx
//
// Badge de chamados de suporte (Serviços > Chamados): aberto + em_atendimento,
// contado server-side. O número vem de `useSidebarBadgeCounts()`, montado uma
// vez no topo da sidebar admin.
// Contrato: docs/contracts/ESCR-271-support-tickets.md.

import { useTranslation } from 'react-i18next';

import { SidebarCountBadge, type SidebarCountBadgeVariant } from './SidebarCountBadge';

export interface SidebarSupportBadgeProps {
  count: number;
  variant?: SidebarCountBadgeVariant;
}

export function SidebarSupportBadge({ count, variant }: SidebarSupportBadgeProps) {
  const { t } = useTranslation('support');
  return (
    <SidebarCountBadge
      count={count}
      variant={variant}
      testId="sidebar-support-badge"
      label={t('tickets.admin.badge_aria', { count })}
    />
  );
}
